import { render, staticRenderFns } from "./RegisterClientLink.vue?vue&type=template&id=4095d5fd&scoped=true"
import script from "./RegisterClientLink.vue?vue&type=script&lang=js"
export * from "./RegisterClientLink.vue?vue&type=script&lang=js"
import style0 from "./RegisterClientLink.vue?vue&type=style&index=0&id=4095d5fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4095d5fd",
  null
  
)

export default component.exports